import './contact.scss';
import { SiGithub, SiLinkedin, SiGmail, SiTwitter, SiInstagram, SiAngular } from "react-icons/si";
import { ImMobile } from "react-icons/im";

export const Contact = () => {
  

  return (
    <div className="main" id="contact">
      <h2>Contact Me.</h2>
      <div className="contact">
        {/* <div className="left">
          <img src="https://ouch-cdn2.icons8.com/sh9U6Ry7b7ftGfJ8IhzOOSPK_xIYdEboZuRymZ8N-wI/rs:fit:1469:912/czM6Ly9pY29uczgu/b3VjaC1wcm9kLmFz/c2V0cy9wbmcvNDkw/L2MwMGQ2MzFlLTgx/MGUtNGMxZi1hZDk2/LTNjM2M4Mzc4NjBh/OC5wbmc.png" alt="" />
        </div> */}
        <div className="right">
          <div>
            <a href="https://github.com/AkashApp" target="_blank" rel='noreferrer' className="contactLinks"><SiGithub/> GitHub</a>
            <a href="https://www.linkedin.com/in/akash-borate-12360b1b0" target="_blank" rel='noreferrer' className="contactLinks"><SiLinkedin/> LinkedIn</a>
            <a href="https://twitter.com/AkashBorate27" target="_blank" rel='noreferrer' className="contactLinks"><SiTwitter/> Twitter</a>
            <a href="https://www.instagram.com/akash_borate.27" target="_blank" rel='noreferrer' className="contactLinks"><SiInstagram/> Instagram</a>
          </div>
          <h3><SiGmail/> 27akashborate@gmail.com</h3>
          <h3><ImMobile/> +91 96 2356 7372</h3>
          <br />
          <div className="AB_Logo">
            <a href="#intro"><SiAngular/></a>
          </div>
          <span>@ Developed by Akash Borate.</span>
          <h5>Built with ReactJS, HTML, JS, SASS. Hosted on Netlify.</h5>
          {/* <div className="AB_Logo">
            <a href="#intro"><img src="https://user-images.githubusercontent.com/93377428/159544779-20b5df76-70bd-4bc7-a71f-8544288ccd8e.png" alt="AB_Logo" /></a>
          </div> */}
        </div>

      </div>
    </div>
  )
}
